import styled from 'styled-components'

export const Container = styled.div.attrs({
    className: 'gerenciador-documentos-container'
})`
	form {
		display: flex;
		flex-direction: column;

		> button {
			align-self: flex-end;
		}
	}
`

export const DocumentosContainer = styled.div`
	grid-area: arquivos;

	.table-container {
		width: calc(100% - 8px);
		margin-top: 24px;
	}
`

export const ModalContent = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 14px;

	p {
		text-align: left;
		width: 100%;
		padding: 0 8px 12px !important;
	}

	img, 
	iframe {
		width: 100%;
	}

	iframe {
		height: 75vh;
	}
`
